/* eslint-disable */
import * as Yup from 'yup';

export const validationSchema = (role) =>
    Yup.object().shape(
        {
            // ----------------------------------------- //
            regionalAccess: Yup.array().when('apartmentAccess', {
                is: (apartmentAccess) => !apartmentAccess || apartmentAccess?.length === 0,
                then: Yup.array().min(1, 'Regional Manager is required').required('Regional Manager is required'),
                otherwise: Yup.array()
            }),
            apartmentAccess: Yup.array().when('regionalAccess', {
                is: (regionalAccess) => !regionalAccess || regionalAccess?.length === 0,
                then: Yup.array().min(1, 'Apartment Manager is required').required('Apartment Manager is required'),
                otherwise: Yup.array()
            }),

            // Listing Properties //
            listingId: Yup.string().nullable(),
            listingAgreement: role === 'ADMIN' ? Yup.string().required('Listing Agreement is required!') : Yup.string().nullable(),
            // listingService: Yup.string().required('Listing Service is required!'),
            listPrice: Yup.number().required('List Price is required!'),
            expirationDate: role === 'ADMIN' ? Yup.date().required('Expiration Date is required!') : Yup.date().nullable(),
            housingVouchers: Yup.string().required('Housing Vouchers is required!'),
            // auctionDate: Yup.date().nullable(),
            streetNumber: Yup.string().required('Street Number is required!'),
            streetDirPrefix: Yup.string().nullable(),
            streetName: Yup.string().required('Street Name is required!'),
            streetDirSuffix: Yup.string().nullable(),
            unitNumber: Yup.string().required('Unit Number is required!'),
            city: Yup.string().required('City is required!'),
            state: Yup.string().required('State is required!'),
            zipCode: Yup.string().required('Zip Code is required!'),
            // postalCode: Yup.string().required('Postal Code is required!'),
            country: Yup.string().required('Country is required!'),
            county: Yup.string().required('County is required!'),
            Subdivision: Yup.string().required('Sub division is required!'),
            mlsArea: role === 'ADMIN' ? Yup.string().required('MLS Area is required!') : Yup.string().nullable(),
            parcelNumber: role === 'ADMIN' ? Yup.string().required('Parcel Number is required!') : Yup.string().nullable(),
            // addionalParecel: Yup.string().required('Additional Parcels is required!'),
            streetTypeOrSuffix: Yup.string().required('Street Type/ Suffix is required!'),
            latitude: role === 'ADMIN' ? Yup.string().required('Latitude is required!') : Yup.string().nullable(),
            longitude: role === 'ADMIN' ? Yup.string().required('Longitude is required!') : Yup.string().nullable(),
            etj: Yup.string().nullable(),
            femaFloodPlain: Yup.array().min(1, 'Fema Flood Plain Conditions is required').required('Fema Flood Plain is required'),
            schoolDistrict: Yup.string().required('School District is required!'),
            elementary: Yup.string().required('Elementary is required!'),
            middleJunior: Yup.string().required('Middle Junior is required!'),
            highSchool: Yup.string().required('High School is required!'),
            taxLegalDescription: role === 'ADMIN' ? Yup.string().required('Tax Legal Description is required!') : Yup.string().nullable(),
            taxLot: Yup.string().nullable(),
            taxBlock: Yup.string().nullable(),
            // specialListingConditions: Yup.array()
            //     .min(1, 'Special Listing Conditions is required')
            //     .required('Special Listing Conditions is required'),
            listingAgreementDoc: role === 'ADMIN' ? Yup.string().required('Listing Agreement Doc is required!') : Yup.string().nullable(),
            // ----------------------------------------- //
            // General Properties //
            propertySubTypes: Yup.string().required('Property Sub Types are required!'),
            // ownershipType: Yup.string().required('Ownership Type is required'),
            levels: Yup.array().min(1, 'Levels is required').required('Levels is required'),
            alsoListedAs: Yup.string().nullable(),
            mainLevelBedrooms: Yup.string().required('Main Level Bedrooms are required'),
            otherLevelBeds: Yup.string().nullable(),
            yearBuilt: Yup.string().required('Year Built is required'),
            // yearBuiltSource: Yup.string().required('Year Built Source is required'),
            bathroomsFull: Yup.string().required('Bathrooms Full is required'),
            bathroomsHalf: Yup.string().required('Bathrooms Half is required'),
            living: Yup.string().required('Living is required'),
            dining: Yup.string().required('Dining is required'),
            livingArea: Yup.string().required('Living Area (SqFt) is required'),
            livingAreaSource: Yup.string().required('Living Area Source is required'),
            garageSpaces: Yup.string().required('Garage Spaces is required'),
            parkingTotal: Yup.string().required('Parking Total is required'),
            parkingFeeFrom: Yup.string().nullable(),
            parkingFeeTo: Yup.string().nullable(),
            parkingFeeFrequency: Yup.string().nullable(),
            directionFaces: Yup.string().required('Direction Face is required'),
            lotSizeAcres: Yup.string().nullable(),
            lotDimensions: Yup.string().nullable(),
            propertyCondition: Yup.array().nullable(),
            constructionMaterials: Yup.array().nullable(),
            parkingFeatures: Yup.array().min(1, 'Parking Features is required').required('Parking Features is required'),
            foundationDetails: Yup.array().nullable(),
            roof: Yup.array().nullable(),
            builderName: Yup.string().nullable(),
            unitStyle: Yup.array().nullable(),
            view: Yup.array().nullable(),
            distanceToWaterAccess: Yup.string().nullable(),
            waterfrontFeatures: Yup.array().nullable(),
            waterBodyName: Yup.string().nullable(),
            lotFeatures: Yup.array().min(1, 'Lot Features is required').required('Lot Features is required'),
            flooring: Yup.array().min(1, 'Flooring Details is required').required('Flooring Details is required'),
            restrictions: Yup.array().nullable(),
            complexName: Yup.string().required('Complex Name is required'),
            unitsInComplex: Yup.string().required('Units In Complex is required'),
            floorPlanName: Yup.string().required('Floor Plan Name/Number is required'),
            smokingInside: Yup.string().required('Smoking Inside is required'),
            moveInSpecialYN: Yup.string().nullable(),
            moveInSpecialDescription: Yup.string().nullable(),
            // ----------------------------------------- //
            // Additional Properties //
            interiorFeatures: Yup.array().min(1, 'Interior Features is required').required('Interior Features is required'),
            exteriorFeatures: Yup.array().min(1, 'Exterior Features is required').required('Exterior Features is required'),
            appliances: Yup.array().min(1, 'Appliances is required').required('Appliances is required'),
            windowFeatures: Yup.array().nullable(),
            securityFeatures: Yup.array().min(1, 'Security Features is required').required('Security Features is required'),
            accessibilityFeatures: Yup.array().min(1, 'Accessibility Features is required').required('Accessibility Features is required'),
            laundryLocation: Yup.array().min(1, 'Laundry Location is required').required('Laundry Location is required'),
            patioAndPorchFeatures: Yup.array().nullable(),
            privatePoolFeatures: Yup.array().min(1, 'Private Pool Features is required').required('Private Pool Features is required'),
            spaFeatures: Yup.array().nullable(),
            horseAmenities: Yup.array().nullable(),
            fencing: Yup.array().nullable(),
            fireplaces: Yup.string().nullable(),
            fireplaceFeatures: Yup.array().nullable(),
            otherStructures: Yup.array().nullable(),
            communityFeatures: Yup.array().min(1, 'Community Features is required').required('Community Features is required'),
            communityWebSite: Yup.string().nullable(),
            guestAccommodations: Yup.array().nullable(),
            guestBeds: Yup.string().nullable(),
            guestFullBaths: Yup.string().nullable(),
            guestHalfBaths: Yup.string().nullable(),
            distanceToUTShuttle: Yup.string().nullable(),
            distanceToMetro: Yup.string().nullable(),
            distanceToLightRail: Yup.string().nullable(),
            furnished: Yup.string().nullable(),
            appliancesMaintained: Yup.array().nullable(),
            // ----------------------------------------- //
            // Rooms Properties //
            rooms: Yup.array().of(
                Yup.object().shape({
                    roomType: Yup.string().nullable(),
                    roomLevel: Yup.string().nullable(),
                    roomFeatures: Yup.array().nullable(),
                    roomDescription: Yup.string().nullable()
                })
            ),
            // ----------------------------------------- //
            // Document Properties //
            disclosures: Yup.array().min(1, 'Disclosures is required').required('Disclosures is required'),
            documentsAvailable: Yup.array().nullable(),
            heating: Yup.array().nullable(),
            cooling: Yup.array().min(1, 'Cooling is required').required('Cooling is required'),
            waterSource: Yup.array().nullable(),
            sewer: Yup.array().min(1, 'Sewer is required').required('Sewer is required'),
            utilities: Yup.array().min(1, 'Utilities is required').required('Utilities is required'),
            ownerPays: Yup.array().min(1, 'Owner Pays is required').required('Owner Pays is required'),
            tenantPays: Yup.array().min(1, 'Tenant Pays is required').required('Tenant Pays is required'),
            meterDescription: Yup.array().nullable(),
            // groundwaterConservDistrict: Yup.string().nullable(),
            // ----------------------------------------- //
            greenEnergyEfficient: Yup.array().nullable(),
            greenSustainability: Yup.array().nullable(),
            greenEnergyVerification: Yup.array()
                .min(1, 'Green Energy Verification is required')
                .of(
                    Yup.object().shape({
                        greenEnergyBuildingVerificationType: Yup.string().nullable(),
                        verificationMetric: Yup.string().nullable(),
                        verificationStatus: Yup.string().nullable(),
                        verificationRating: Yup.string().nullable(),
                        verificationYear: Yup.string().nullable()
                    })
                )
                .required('Green Energy Verification is required'),

            // Financial Information Properties
            // association: Yup.string().required('Association is required'),
            // associationRequirement: Yup.string().nullable(),
            // associationFeesInclude: Yup.array().nullable(),
            // associationName: Yup.string().nullable(),
            // associationFeeFrequency: Yup.string().required('Association fee frequency is required'),
            // acceptableFinancing: Yup.array().required('Acceptable financing is required'),
            // hOAManagementCo: Yup.string().nullable(),
            // associationTransferFee: Yup.string().nullable(),
            // estimatedTax: Yup.string().required('Estimated tax is required'),
            // taxYear: Yup.string().required('Tax year is required'),
            // taxAnnualAmount: Yup.string().nullable(),
            // taxAssessedValue: Yup.string().required('Tax assessed value is required'),
            // taxRate: Yup.string().required('Tax rate is required'),
            // title: Yup.string().nullable(),
            // preferredTitleCompany: Yup.string().nullable(),
            // associationFee: Yup.string().nullable(),
            // specialAssessment: Yup.string().nullable(),
            // buyerIncentive: Yup.array().required('Buyer incentive is required'),
            // taxExemptions: Yup.array().required('Tax exemptions are required'),
            // possession: Yup.array().required('Possession is required'),

            // How To Apply Properties
            associationYN: Yup.string().nullable(),
            applicationFee: Yup.string().required('Application Fee is required'),
            applicationFeePerPerson: Yup.string().required('Application Fee Per Person is required'),
            applicationFeePayableTo: Yup.string().required('Application Fee Payable To is required'),
            managedBy: Yup.string().required('Managed By is required'),
            securityDeposit: Yup.string().required('Security Deposit is required'),
            securityDepositPayableTo: Yup.string().required('Security Deposit Payable To is required'),
            administrationFee: Yup.string().required('Administration Fee is required'),
            administrationFeePayableTo: Yup.string().required('Administration Fee Payable To is required'),
            firstMonthRentPayableTo: Yup.string().required('First Month Rent Payable To is required'),
            shortTermPremium: Yup.string().nullable(),
            shortTermPremiumAmount: Yup.string().nullable(),
            onSiteCompliance: Yup.string().required('On-Site Compliance is required'),
            renterInsuranceRequired: Yup.string().required('Renter Insurance Required is required'),
            minimumLeaseMonths: Yup.string().nullable(),
            maximumLeaseMonths: Yup.string().nullable(),
            availableDate: Yup.date().required('Available Date is required'),
            certifiedFunds: Yup.string().required('Certified Funds is required'),
            leaseGuarantorYN: Yup.string().required('Lease Guarantor Y/N is required'),
            leaseTerm: Yup.string().required('Lease Term is required'),
            applicationPolicy: Yup.string().required('Application Policy required'),
            petsAllowed: Yup.array().min(1, 'Pets Allowed is required').required('Pets Allowed is required'),
            petDeposit: Yup.string().required('Pet Deposit required'),
            petDepositPerPet: Yup.string().required('Pet Deposit Per Pet required'),
            monthlyPetRent: Yup.string().required('Monthly Pet Rent is required'),
            maxNumberOfPets: Yup.string().required('Max Number of Pets are required'),
            monthlyPetRentPerPet: Yup.string().required('Monthly Pet Rent Per Pet is required'),
            additionalPetFee: Yup.string().required('Additional Pet Fee is required'),
            additionPetFeeDescription: Yup.string().required('Additional Pet Fee Description is required'),
            applicationRequired: Yup.array().min(1, 'Application Required is required').required('Application Required is required'),
            oneTimeExpenses: Yup.array().min(1, 'One Time Expenses are required').required('One Time Expenses are required'),
            recurringExpenses: Yup.array().nullable(),
            applicationDeliverAddress: Yup.string().required('Application Deliver Address is required'),
            websiteAppLinkPublicView: Yup.string().required('Website App Link Public View is required'),
            websiteAppLinkAgentView: Yup.string().nullable(),
            sellerContributionsYN: Yup.string().required('Owner contributions Y/N (Locator Commissions) is required'),
            intermediaryYN: role === 'ADMIN' ? Yup.string().required('Intermediary Y/N is required!') : Yup.string().nullable(),
            rentSpreeOnlineApplicationYN: Yup.string().required('RentSpree Online Application Y/N is required'),
            commissionType: Yup.string().nullable(),
            commission: Yup.string().required('Commission is required'),
            // commission: Yup.number()
            //     .typeError('Value must be a number')
            //     .when('commissionType', {
            //         is: 'percentage',
            //         then: Yup.number().min(0, 'Value must be at least 0').max(100, 'Value must be at most 100').required('Value is required'),
            //         otherwise: Yup.number().required('Value is required')
            //     }),

            // Occupant Properties
            occupantType: role === 'ADMIN' ? Yup.string().required('Occupant Type is required!') : Yup.string().nullable(),
            ownerName: Yup.string().required('Owner name is required'),
            accessCode: Yup.string().nullable(),
            lockboxType: role === 'ADMIN' ? Yup.string().required('Lockbox Type is required!') : Yup.string().nullable(),
            lockboxLocation: Yup.string().nullable(),
            lockboxSerialNumber: Yup.string().nullable(),
            showingContactName: Yup.string().nullable(),
            showingContactPhone: Yup.string().required('Showing Contact Phone is required!'),
            showingServicePhone: Yup.string().nullable(),
            showingContactType: Yup.array().nullable(),
            showingRequirements:
                role === 'ADMIN'
                    ? Yup.array().min(1, 'Showing Requirements are required').required('Showing Requirements are required')
                    : Yup.array().nullable(),
            showingInstructions: role === 'ADMIN' ? Yup.string().required('Showing Instructions is required!') : Yup.string().nullable(),
            managementCompany: Yup.string().nullable(),
            managementCompanyRep: Yup.string().nullable(),
            managementCompanyPhone: Yup.string().nullable(),

            // Agent Properties
            listAgentMLSID: Yup.string().nullable(),
            coListAgentMLSID: Yup.string().nullable(),
            subAgencyCompType: Yup.string().nullable(),
            subAgencyComp: Yup.string().nullable(),
            buyerAgencyCompType: Yup.string().nullable(),
            buyerAgencyComp: Yup.string().nullable(),
            bonusToBA: Yup.string().nullable(),
            bonusToBAAmount: Yup.string().nullable(),
            dualVariableComp: Yup.string().nullable(),
            intermediary: Yup.string().nullable(),
            listingOverride: role === 'ADMIN' ? Yup.string().required('Listing Override is required!') : Yup.string().nullable(),

            // Remarks Properties
            directions: Yup.string().required('Directions are required'),
            privateRemarks: role === 'ADMIN' ? Yup.string().required('Private Remarks is required!') : Yup.string().nullable(),
            publicRemarks: Yup.string().required('Public remarks are required'),
            syndicationRemarks: Yup.string().nullable(),
            brandedVirtualTourURL: Yup.string().nullable(),
            unbrandedVirtualTourURL: Yup.string().nullable(),
            brandedVideoTourURL: Yup.string().nullable(),
            unbrandedVideoTourURL: Yup.string().nullable(),
            listingDetailedURL: Yup.string().nullable(),
            propertyPanorama: Yup.string().nullable(),
            internetListingDisplay: Yup.string().required('Internet listing display is required'),
            internetAutomatedValuation: Yup.string().required('Internet automated valuation is required'),
            internetConsumerComment: Yup.string().required('Internet consumer comment is required'),
            internetAddressDisplay: Yup.string().required('Internet address display is required'),
            listingWillAppearOn: Yup.array().min(1, 'Listing Will Appear On is required').required('Listing Will Appear On is required')
        },
        [['regionalAccess', 'apartmentAccess']]
    );

export const defaultValues = (user) => {
    return {
        // Listing Information
        regionalAccess: [],
        apartmentAccess: [],

        listingId: '',
        listingAgreement: 'Exclusive Right To Lease',
        listingAgreementDoc: '',
        listPrice: '',
        housingVouchers: '',
        expirationDate: null,

        // Location Information
        streetNumber: '',
        streetDirPrefix: '',
        streetDirSuffix: '',
        unitNumber: '',
        taxLot: '',
        taxBlock: '',
        latitude: '',
        longitude: '',
        streetName: '',
        streetTypeOrSuffix: '',
        county: '',
        country: '',
        city: '',
        state: '',
        zipCode: '',
        taxLegalDescription: '',
        parcelNumber: '',
        mlsArea: '',
        etj: '',
        Subdivision: '',
        femaFloodPlain: [],

        // School Information
        outOfStateSchoolDistrict: '',
        elementaryOther: '',
        middleJuniorOther: '',
        highSchoolOther: '',
        schoolDistrict: '',
        elementary: '',
        middleJunior: '',
        highSchool: '',

        // General Information
        alsoListedAs: '',
        otherLevelBeds: '',
        builderName: '',
        distanceToWaterAccess: '',
        waterBodyName: '',
        mainLevelBedrooms: '',
        yearBuilt: '',
        bathroomsFull: '',
        bathroomsHalf: '',
        living: '',
        dining: '',
        livingArea: '',
        garageSpaces: '',
        parkingTotal: '',
        parkingFeeFrom: '',
        parkingFeeTo: '',
        parkingFeeFrequency: '',
        lotSizeAcres: '',
        lotDimensions: '',
        livingAreaSource: '',
        directionFaces: '',
        levels: [],
        propertySubTypes: '',
        propertyCondition: [],
        constructionMaterials: [],
        parkingFeatures: [],
        foundationDetails: [],
        roof: [],
        view: [],
        lotFeatures: [],
        waterfrontFeatures: [],
        flooring: [],
        restrictions: [],
        unitStyle: [],
        complexName: user?.roleName === 'APARTMENT_MANAGER' ? user?.complexName || '' : '',
        complex_id: user?.roleName === 'APARTMENT_MANAGER' ? user?.complex_id || '' : '',
        unitsInComplex: '',
        floorPlanName: '',
        smokingInside: '',
        moveInSpecialYN: '',
        moveInSpecialDescription: '',

        // Additional Information
        communityWebSite: '',
        guestBeds: '',
        guestFullBaths: '',
        guestHalfBaths: '',
        fireplaces: '',
        interiorFeatures: [],
        exteriorFeatures: [],
        appliances: [],
        windowFeatures: [],
        securityFeatures: [],
        accessibilityFeatures: [],
        laundryLocation: [],
        patioAndPorchFeatures: [],
        horseAmenities: [],
        privatePoolFeatures: [],
        fencing: [],
        otherStructures: [],
        guestAccommodations: [],
        communityFeatures: [],
        distanceToUTShuttle: '',
        distanceToMetro: '',
        distanceToLightRail: '',
        spaFeatures: [],
        fireplaceFeatures: [],
        furnished: '',
        appliancesMaintained: [],

        // Rooms Properties
        rooms: [
            {
                roomType: '',
                roomLevel: '',
                roomFeatures: [],
                roomDescription: ''
            }
        ],

        // Documents and Utilities
        disclosures: [],
        documentsAvailable: [],
        utilities: [],
        heating: [],
        cooling: [],
        waterSource: [],
        sewer: [],
        ownerPays: [],
        meterDescription: [],
        tenantPays: [],

        // Green Energy
        greenEnergyEfficient: [],
        greenSustainability: [],
        greenEnergyVerification: [
            {
                greenEnergyBuildingVerificationType: '',
                verificationMetric: '',
                verificationStatus: '',
                verificationRating: '',
                verificationYear: ''
            }
        ],

        // How To Apply Information
        associationYN: '',
        applicationFee: '',
        applicationFeePerPerson: '',
        applicationFeePayableTo: '',
        managedBy: '',
        securityDeposit: '',
        securityDepositPayableTo: '',
        administrationFee: '',
        administrationFeePayableTo: '',
        firstMonthRentPayableTo: '',
        shortTermPremium: '',
        shortTermPremiumAmount: '',
        onSiteCompliance: '',
        renterInsuranceRequired: '',
        minimumLeaseMonths: '',
        maximumLeaseMonths: '',
        availableDate: null,
        certifiedFunds: '',
        leaseGuarantorYN: '',
        leaseTerm: '',
        applicationPolicy: '',
        petsAllowed: [],
        petDeposit: '',
        maxNumberOfPets: '',
        petDepositPerPet: '',
        monthlyPetRent: '',
        monthlyPetRentPerPet: '',
        additionalPetFee: '',
        additionPetFeeDescription: '',
        applicationRequired: [],
        oneTimeExpenses: [],
        recurringExpenses: [],
        applicationDeliverAddress: '',
        websiteAppLinkPublicView: '',
        websiteAppLinkAgentView: '',
        sellerContributionsYN: '',
        intermediaryYN: 'NO',
        rentSpreeOnlineApplicationYN: '',
        commissionType: '',
        commission: '',

        // Showing Information
        accessCode: '',
        showingContactName: user?.firstName + ' ' + user?.lastName,
        showingContactPhone: '',
        showingServicePhone: '',
        showingInstructions: '',
        occupantType: 'Vacant',
        ownerName: '',
        lockboxLocation: '',
        lockboxType: 'None',
        showingRequirements: [
            'Call First - Go',
            'Go',
            'Key with Management Company',
            'Key in Office',
            'Restricted Hours',
            'See Showing Instructions'
        ],
        showingContactType: ['Property Manager'],
        lockboxSerialNumber: '',
        managementCompany: user?.roleName === 'APARTMENT_MANAGER' ? user?.company?.name || '' : '',
        managementCompanyPhone: user?.roleName === 'APARTMENT_MANAGER' ? user?.company?.phoneNo || '' : '',
        managementCompanyRep: '',

        // agent information
        listAgentMLSID: '',
        coListAgentMLSID: '',

        // Compensation Information
        bonusToBA: '',
        bonusToBAAmount: '',
        subAgencyCompType: '',
        buyerAgencyCompType: '',
        subAgencyComp: '',
        buyerAgencyComp: '',
        dualVariableComp: '',
        intermediary: '',

        // attribution information
        listingOverride: '',

        // Remarks Information
        privateRemarks: '',
        syndicationRemarks: '',
        directions: '',
        publicRemarks: '',

        // Virtual Tours
        brandedVideoTourURL: '',
        unbrandedVideoTourURL: '',
        listingDetailedURL: '',
        propertyPanorama: '',

        // Internet Display
        internetListingDisplay: '',
        internetAutomatedValuation: '',
        internetConsumerComment: '',
        internetAddressDisplay: '',
        listingWillAppearOn: []
    };
};

export const complexSpecific = [
    'state',
    'zipCode',
    'taxLegalDescription',
    'mlsArea',
    'latitude',
    'longitude',
    'etj',
    'lotSizeAcres',
    'waterfrontFeatures',
    'propertyCondition',
    'constructionMaterials',
    'foundationDetails',
    'streetTypeOrSuffix',
    'roof',
    'builderName',
    'horseAmenities',
    'communityFeatures',
    'greenEnergyEfficient',
    'greenSustainability',
    'intermediaryYN',
    'applicationFeePerPerson',
    'applicationFeePayableTo',
    'administrationFee',
    'administrationFeePayableTo',
    'shortTermPremium',
    'shortTermPremiumAmount',
    'petDepositPerPet',
    'monthlyPetRentPerPet',
    'additionPetFeeDescription',
    'additionalPetFee',
    'minimumLeaseMonths',
    'maximumLeaseMonths',
    'leaseGuarantorYN',
    'recurringExpenses',
    'sellerContributionsYN',
    'applicationDeliverAddress',
    'websiteAppLinkPublicView',
    'websiteAppLinkAgentView',
    'listingOverride',
    'securityDepositPayableTo',
    'applicationFee',
    'applicationPolicy',
    'applicationRequired',
    'certifiedFunds',
    'city',
    'cooling',
    'county',
    'directions',
    'disclosures',
    'elementary',
    'exteriorFeatures',
    'femaFloodPlain',
    'firstMonthRentPayableTo',
    'highSchool',
    'housingVouchers',
    'internetAddressDisplay',
    'internetAutomatedValuation',
    'internetConsumerComment',
    'internetListingDisplay',
    'laundryLocation',
    'leaseTerm',
    'lotFeatures',
    'managedBy',
    'maxNumberOfPets',
    'middleJunior',
    'monthlyPetRent',
    'oneTimeExpenses',
    'onSiteCompliance',
    'ownerName',
    'ownerPays',
    'petDeposit',
    'petsAllowed',
    'privatePoolFeatures',
    'postalCode',
    'propertySubTypes',
    'publicRemarks',
    'renterInsuranceRequired',
    'rentSpreeOnlineApplicationYN',
    'schoolDistrict',
    'securityDeposit',
    'securityFeatures',
    'sewer',
    'smokingInside',
    'streetName',
    'streetNumber',
    'streetDirSuffix',
    'streetDirPrefix',
    'Subdivision',
    'tenantPays',
    'utilities',
    'yearBuilt',
    'outOfStateCounty',
    'outOfStateCity',
    'country',
    'taxBlock',
    'taxLot',
    'elementaryOther',
    'middleJuniorOther',
    'highSchoolOther',
    'complexName',
    'complex_id',
    'unitsInComplex'
];
export const complexSpecificDuplicate = [
    'state',
    'zipCode',
    'taxLegalDescription',
    'mlsArea',
    'latitude',
    'longitude',
    'etj',
    'lotSizeAcres',
    'waterfrontFeatures',
    'propertyCondition',
    'constructionMaterials',
    'foundationDetails',
    'streetTypeOrSuffix',
    'roof',
    'builderName',
    'horseAmenities',
    'communityFeatures',
    'greenEnergyEfficient',
    'greenSustainability',
    'intermediary',
    'applicationFeePerPerson',
    'applicationFeePayableTo',
    'administrationFee',
    'administrationFeePayableTo',
    'shortTermPremium',
    'shortTermPremiumAmount',
    'petDepositPerPet',
    'monthlyPetRentPerPet',
    'additionalPetFeeDescription',
    'additionalPetFee',
    'minimumLeaveMonths',
    'maximumLeaveMonths',
    'leaseGuarantorYN',
    'recurringExpense',
    'sellerContributionYN',
    'applicationDriverAddress',
    'websiteAppLinkPublicView',
    'websiteAppLinkAgentView',
    'listingOverride',
    'securityDepositPayableTo',
    'applicationFee',
    'applicationPolicy',
    'applicationRequired',
    'certifiedFunds',
    'city',
    'cooling',
    'county',
    'directions',
    'disclosures',
    'elementy',
    'exteriorFeatures',
    'femaFloodPlain',
    'firstMonthRentPayableTo',
    'highSchool',
    'housingVouchers',
    'internetAddressDisplay',
    'internetAutomatedValuationDisplay',
    'internetConsumerComment',
    'internetEntireListingDisplay',
    'laundryLocation',
    'leaseTerm',
    'lotFeatures',
    'managedBy',
    'maxNumberOfPets',
    'middleOrJunior',
    'monthlyPetRent',
    'oneTimeExpense',
    'onSiteCompliance',
    'ownerName',
    'ownerPays',
    'petDeposit',
    'petAllowed',
    'privatePoolFeatures',
    'postalCode',
    'propertySubType',
    'publicRemarks',
    'renterInsuranceRquired',
    'rentSpreeOnlineApplicationYN',
    'schoolDistrict',
    'securityDeposit',
    'securityFeatures',
    'sewer',
    'smokingInside',
    'streetName',
    'streetNumber',
    'streetDirSuffix',
    'streetDirPrefix',
    'subdivision',
    'tenantPays',
    'utilities',
    'yearBuilt',
    'outOfStateCounty',
    'outOfStateCity',
    'country',
    'taxBlock',
    'taxLot',
    'elementy',
    'middleOrJunior',
    'highSchoolOther',
    'complexName',
    'complex_id',
    'unitsInComplex'
];

export const completeDuplicate = [
    'listingAgreement',
    'listingAgreementDoc',
    'listPrice',
    'housingVouchers',
    'expirationDate',
    'streetNumber',
    'streetDirPrefix',
    'streetDirSuffix',
    'unitNumber',
    'taxLot',
    'taxBlock',
    'latitude',
    'longitude',
    'streetName',
    'streetTypeOrSuffix',
    'county',
    'country',
    'city',
    'state',
    'zipCode',
    'taxLegalDescription',
    'parcelNumber',
    'mlsArea',
    'etj',
    'Subdivision',
    'femaFloodPlain',
    'outOfStateSchoolDistrict',
    'elementaryOther',
    'middleJuniorOther',
    'highSchoolOther',
    'schoolDistrict',
    'elementary',
    'middleJunior',
    'highSchool',
    'alsoListedAs',
    'otherLevelBeds',
    'builderName',
    'distanceToWaterAccess',
    'waterBodyName',
    'mainLevelBedrooms',
    'yearBuilt',
    'bathroomsFull',
    'bathroomsHalf',
    'living',
    'dining',
    'livingArea',
    'garageSpaces',
    'parkingTotal',
    'parkingFeeFrom',
    'parkingFeeTo',
    'parkingFeeFrequency',
    'lotSizeAcres',
    'lotDimensions',
    'livingAreaSource',
    'directionFaces',
    'levels',
    'propertySubTypes',
    'propertyCondition',
    'constructionMaterials',
    'parkingFeatures',
    'foundationDetails',
    'roof',
    'view',
    'lotFeatures',
    'waterfrontFeatures',
    'flooring',
    'restrictions',
    'unitStyle',
    'complexName',
    'complex_id',
    'unitsInComplex',
    'floorPlanName',
    'smokingInside',
    'moveInSpecialYN',
    'moveInSpecialDescription',
    'communityWebSite',
    'guestBeds',
    'guestFullBaths',
    'guestHalfBaths',
    'fireplaces',
    'interiorFeatures',
    'exteriorFeatures',
    'appliances',
    'windowFeatures',
    'securityFeatures',
    'accessibilityFeatures',
    'laundryLocation',
    'patioAndPorchFeatures',
    'horseAmenities',
    'privatePoolFeatures',
    'fencing',
    'otherStructures',
    'guestAccommodations',
    'communityFeatures',
    'distanceToUTShuttle',
    'distanceToMetro',
    'distanceToLightRail',
    'spaFeatures',
    'fireplaceFeatures',
    'furnished',
    'appliancesMaintained',
    'rooms',
    'disclosures',
    'documentsAvailable',
    'utilities',
    'heating',
    'cooling',
    'waterSource',
    'sewer',
    'ownerPays',
    'meterDescription',
    'tenantPays',
    'greenEnergyEfficient',
    'greenSustainability',
    'greenEnergyVerification',
    'associationYN',
    'applicationFee',
    'applicationFeePerPerson',
    'applicationFeePayableTo',
    'managedBy',
    'securityDeposit',
    'securityDepositPayableTo',
    'administrationFee',
    'administrationFeePayableTo',
    'firstMonthRentPayableTo',
    'shortTermPremium',
    'shortTermPremiumAmount',
    'onSiteCompliance',
    'renterInsuranceRequired',
    'minimumLeaseMonths',
    'maximumLeaseMonths',
    'availableDate: ',
    'certifiedFunds',
    'leaseGuarantorYN',
    'leaseTerm',
    'applicationPolicy',
    'petsAllowed',
    'petDeposit',
    'maxNumberOfPets',
    'petDepositPerPet',
    'monthlyPetRent',
    'monthlyPetRentPerPet',
    'additionalPetFee',
    'additionPetFeeDescription',
    'applicationRequired',
    'oneTimeExpenses',
    'recurringExpenses',
    'applicationDeliverAddress',
    'websiteAppLinkPublicView',
    'websiteAppLinkAgentView',
    'sellerContributionsYN',
    'intermediaryYN',
    'rentSpreeOnlineApplicationYN',
    'commissionType',
    'commission',
    'accessCode',
    'showingContactName',
    'showingContactPhone',
    'showingServicePhone',
    'showingInstructions',
    'occupantType',
    'ownerName',
    'lockboxLocation',
    'lockboxType',
    'showingRequirements',
    'showingContactType',
    'lockboxSerialNumber',
    'managementCompany',
    'managementCompanyPhone',
    'managementCompanyRep',
    'listAgentMLSID',
    'coListAgentMLSID',
    'bonusToBA',
    'bonusToBAAmount',
    'subAgencyCompType',
    'buyerAgencyCompType',
    'subAgencyComp',
    'buyerAgencyComp',
    'dualVariableComp',
    'intermediary',
    'listingOverride',
    'privateRemarks',
    'syndicationRemarks',
    'directions',
    'publicRemarks',
    'brandedVideoTourURL',
    'unbrandedVideoTourURL',
    'listingDetailedURL',
    'propertyPanorama',
    'internetListingDisplay',
    'internetAutomatedValuation',
    'internetConsumerComment',
    'internetAddressDisplay',
    'listingWillAppearOn'
];

export const unitSpecific = [
    'accessibilityFeatures',
    'appliances',
    'availableDate',
    'bathroomsFull',
    'bathroomsHalf',
    'directionFaces',
    'expirationDate',
    'exteriorFeatures',
    'flooring',
    'garageSpaces',
    'interiorFeatures',
    'levels',
    'listPrice',
    'livingAreaSource',
    'mainLevelBedrooms',
    'dining',
    'living',
    'parkingFeatures',
    'parkingTotal',
    'unitNumber',
    'floorPlanName',
    'otherLevelBeds',
    'alsoListedAs',
    'unitStyle',
    'moveInSpecialYN',
    'moveInSpecialDescription',
    'furnished',
    'fencing',
    'appliancesMaintained',
    'fireplaces',
    'fireplaceFeatures',
    'patioAndPorchFeatures',
    'windowFeatures',
    'guestAccommodations',
    'guestBeds',
    'guestFullBaths',
    'guestHalfBaths',
    'rooms',
    'accessCode',
    'lockboxLocation',
    'lockboxSerialNumber'
];

export const reverseMap = {
    listingId: 'Listing Details',
    listingAgreement: 'Listing Details',
    listingAgreementDoc: 'Listing Details',
    listPrice: 'Listing Details',
    housingVouchers: 'Listing Details',
    expirationDate: 'Listing Details',

    streetNumber: 'Listing Details',
    streetDirPrefix: 'Listing Details',
    streetDirSuffix: 'Listing Details',
    unitNumber: 'Listing Details',
    taxLot: 'Listing Details',
    taxBlock: 'Listing Details',
    latitude: 'Listing Details',
    longitude: 'Listing Details',
    streetName: 'Listing Details',
    streetTypeOrSuffix: 'Listing Details',
    county: 'Listing Details',
    country: 'Listing Details',
    city: 'Listing Details',
    state: 'Listing Details',
    zipCode: 'Listing Details',
    taxLegalDescription: 'Listing Details',
    parcelNumber: 'Listing Details',
    mlsArea: 'Listing Details',
    etj: 'Listing Details',
    femaFloodPlain: 'Listing Details',

    outOfStateSchoolDistrict: 'Listing Details',
    elementaryOther: 'Listing Details',
    middleJuniorOther: 'Listing Details',
    highSchoolOther: 'Listing Details',
    schoolDistrict: 'Listing Details',
    elementary: 'Listing Details',
    middleJunior: 'Listing Details',
    highSchool: 'Listing Details',

    alsoListedAs: 'General Info.',
    otherLevelBeds: 'General Info.',
    builderName: 'General Info.',
    distanceToWaterAccess: 'General Info.',
    waterBodyName: 'General Info.',
    mainLevelBedrooms: 'General Info.',
    yearBuilt: 'General Info.',
    bathroomsFull: 'General Info.',
    bathroomsHalf: 'General Info.',
    living: 'General Info.',
    dining: 'General Info.',
    livingArea: 'General Info.',
    garageSpaces: 'General Info.',
    parkingTotal: 'General Info.',
    parkingFeeFrom: 'General Info.',
    parkingFeeTo: 'General Info.',
    parkingFeeFrequency: 'General Info.',
    lotSizeAcres: 'General Info.',
    lotDimensions: 'General Info.',
    livingAreaSource: 'General Info.',
    directionFaces: 'General Info.',
    levels: 'General Info.',
    propertySubTypes: 'General Info.',
    propertyCondition: 'General Info.',
    constructionMaterials: 'General Info.',
    parkingFeatures: 'General Info.',
    foundationDetails: 'General Info.',
    roof: 'General Info.',
    view: 'General Info.',
    lotFeatures: 'General Info.',
    waterfrontFeatures: 'General Info.',
    restrictions: 'General Info.',
    unitStyle: 'General Info.',
    complexName: 'General Info.',
    complex_id: 'General Info.',
    unitsInComplex: 'General Info.',
    floorPlanName: 'General Info.',
    smokingInside: 'General Info.',
    moveInSpecialYN: 'General Info.',
    moveInSpecialDescription: 'General Info.',

    flooring: 'Property Details',
    communityWebSite: 'Property Details',
    guestBeds: 'Property Details',
    guestFullBaths: 'Property Details',
    guestHalfBaths: 'Property Details',
    fireplaces: 'Property Details',
    interiorFeatures: 'Property Details',
    exteriorFeatures: 'Property Details',
    appliances: 'Property Details',
    windowFeatures: 'Property Details',
    securityFeatures: 'Property Details',
    accessibilityFeatures: 'Property Details',
    laundryLocation: 'Property Details',
    patioAndPorchFeatures: 'Property Details',
    horseAmenities: 'Property Details',
    privatePoolFeatures: 'Property Details',
    fencing: 'Property Details',
    otherStructures: 'Property Details',
    guestAccommodations: 'Property Details',
    communityFeatures: 'Property Details',
    distanceToUTShuttle: 'Property Details',
    distanceToMetro: 'Property Details',
    distanceToLightRail: 'Property Details',
    spaFeatures: 'Property Details',
    fireplaceFeatures: 'Property Details',
    furnished: 'Property Details',
    appliancesMaintained: 'Property Details',

    // rooms: 'Property Overview',

    disclosures: 'Essential Information',
    documentsAvailable: 'Essential Information',
    utilities: 'Essential Information',
    heating: 'Essential Information',
    cooling: 'Essential Information',
    waterSource: 'Essential Information',
    sewer: 'Essential Information',
    ownerPays: 'Essential Information',
    meterDescription: 'Essential Information',
    tenantPays: 'Essential Information',

    greenEnergyEfficient: 'Property Overview',
    greenSustainability: 'Property Overview',
    greenEnergyBuildingVerificationType: 'Property Overview',
    verificationMetric: 'Property Overview',
    verificationStatus: 'Property Overview',
    verificationRating: 'Property Overview',
    verificationYear: 'Property Overview',

    associationYN: 'Occupant & Management',
    applicationFee: 'Occupant & Management',
    applicationFeePerPerson: 'Occupant & Management',
    applicationFeePayableTo: 'Occupant & Management',
    managedBy: 'Occupant & Management',
    securityDeposit: 'Occupant & Management',
    securityDepositPayableTo: 'Occupant & Management',
    administrationFee: 'Occupant & Management',
    administrationFeePayableTo: 'Occupant & Management',
    firstMonthRentPayableTo: 'Occupant & Management',
    shortTermPremium: 'Occupant & Management',
    shortTermPremiumAmount: 'Occupant & Management',
    onSiteCompliance: 'Occupant & Management',
    renterInsuranceRequired: 'Occupant & Management',
    minimumLeaseMonths: 'Occupant & Management',
    maximumLeaseMonths: 'Occupant & Management',
    availableDate: 'Occupant & Management',
    certifiedFunds: 'Occupant & Management',
    leaseGuarantorYN: 'Occupant & Management',
    leaseTerm: 'Occupant & Management',
    applicationPolicy: 'Occupant & Management',
    petsAllowed: 'Occupant & Management',
    petDeposit: 'Occupant & Management',
    maxNumberOfPets: 'Occupant & Management',
    petDepositPerPet: 'Occupant & Management',
    monthlyPetRent: 'Occupant & Management',
    monthlyPetRentPerPet: 'Occupant & Management',
    additionalPetFee: 'Occupant & Management',
    additionPetFeeDescription: 'Occupant & Management',
    applicationRequired: 'Occupant & Management',
    oneTimeExpenses: 'Occupant & Management',
    recurringExpenses: 'Occupant & Management',
    applicationDeliverAddress: 'Occupant & Management',
    websiteAppLinkPublicView: 'Occupant & Management',
    websiteAppLinkAgentView: 'Occupant & Management',
    sellerContributionsYN: 'Occupant & Management',
    intermediaryYN: 'Occupant & Management',
    rentSpreeOnlineApplicationYN: 'Occupant & Management',

    accessCode: 'Property Insights',
    showingContactName: 'Property Insights',
    showingContactPhone: 'Property Insights',
    showingServicePhone: 'Property Insights',
    showingInstructions: 'Property Insights',
    occupantType: 'Property Insights',
    ownerName: 'Property Insights',
    lockboxLocation: 'Property Insights',
    lockboxType: 'Property Insights',
    showingRequirements: 'Property Insights',
    showingContactType: 'Property Insights',
    lockboxSerialNumber: 'Property Insights',
    managementCompany: 'Property Insights',
    managementCompanyPhone: 'Property Insights',
    managementCompanyRep: 'Property Insights',

    listAgentMLSID: 'Essential Information',
    coListAgentMLSID: 'Essential Information',
    bonusToBA: 'Essential Information',
    bonusToBAAmount: 'Essential Information',
    subAgencyCompType: 'Essential Information',
    buyerAgencyCompType: 'Essential Information',
    subAgencyComp: 'Essential Information',
    buyerAgencyComp: 'Essential Information',
    dualVariableComp: 'Essential Information',
    intermediary: 'Essential Information',
    listingOverride: 'Essential Information',

    privateRemarks: 'Property Insights',
    syndicationRemarks: 'Property Insights',
    directions: 'Property Insights',
    publicRemarks: 'Property Insights',
    brandedVirtualTourURL: 'Property Insights',
    unbrandedVirtualTourURL: 'Property Insights',
    brandedVideoTourURL: 'Property Insights',
    unbrandedVideoTourURL: 'Property Insights',
    listingDetailedURL: 'Property Insights',
    propertyPanorama: 'Property Insights',
    internetListingDisplay: 'Property Insights',
    internetAutomatedValuation: 'Property Insights',
    internetConsumerComment: 'Property Insights',
    internetAddressDisplay: 'Property Insights',
    listingWillAppearOn: 'Property Insights'
};

export const entireListing = [
    'additionalInformation',
    'agentInformation',
    'attachments',
    'attributionContact',
    'completion',
    'documentsAndUtilities',
    'generalInformation',
    'greenEnergy',
    'howToApply',
    'internetDisplay',
    'leaseDate',
    'listingInformation',
    'locationInformation',
    'remarksInformation',
    'rooms',
    'schoolInformation',
    'showingInformation',
    'virtualTours'
];
export const excludedKeys = ['listingStatus', 'completion', 'rooms', 'greenEnergy', 'specialUserAccess', 'listPriceUpdatedAt'];

// Key items to search for
export const keyItemsPairs = ['complexName', 'floorPlanName', 'unit', 'listPrice', 'livingArea', 'mainLevelBedrooms', 'bathroomsFull'];
